import React from 'react';
import { useAuth, USER_ROLES } from '../context/AuthContext';
import { Shield, User, Crown } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const RoleSwitcher = () => {
  const { user, switchRole } = useAuth();

  const getRoleIcon = (role) => {
    switch (role) {
      case USER_ROLES.ADMIN:
        return <Shield size={14} className="text-red-400" />;
      case USER_ROLES.PAID:
        return <Crown size={14} className="text-yellow-400" />;
      default:
        return <User size={14} className="text-gray-400" />;
    }
  };

  const getRoleLabel = (role) => {
    switch (role) {
      case USER_ROLES.ADMIN:
        return 'Admin';
      case USER_ROLES.PAID:
        return 'Premium';
      default:
        return 'Free';
    }
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-gray-400 text-xs">Demo:</span>
      <Select value={user?.role} onValueChange={switchRole}>
        <SelectTrigger className="w-[120px] h-8 bg-[#1a1a2e] border-gray-700 text-white text-xs">
          <SelectValue>
            <span className="flex items-center gap-2">
              {getRoleIcon(user?.role)}
              {getRoleLabel(user?.role)}
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-[#1a1a2e] border-gray-700">
          <SelectItem value={USER_ROLES.FREE} className="text-white hover:bg-purple-600/30">
            <span className="flex items-center gap-2">
              <User size={14} className="text-gray-400" />
              Free User
            </span>
          </SelectItem>
          <SelectItem value={USER_ROLES.PAID} className="text-white hover:bg-purple-600/30">
            <span className="flex items-center gap-2">
              <Crown size={14} className="text-yellow-400" />
              Premium User
            </span>
          </SelectItem>
          <SelectItem value={USER_ROLES.ADMIN} className="text-white hover:bg-purple-600/30">
            <span className="flex items-center gap-2">
              <Shield size={14} className="text-red-400" />
              Admin
            </span>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default RoleSwitcher;
